import { render, staticRenderFns } from "./CameraSelectorButton.vue?vue&type=template&id=00c07dd4&scoped=true"
import script from "./CameraSelectorButton.vue?vue&type=script&lang=js"
export * from "./CameraSelectorButton.vue?vue&type=script&lang=js"
import style0 from "./CameraSelectorButton.vue?vue&type=style&index=0&id=00c07dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c07dd4",
  null
  
)

export default component.exports